export const jwtDecode = () => {
    try {
        const token = localStorage.getItem("authToken");
        if (!token) {  // Handle the case where no token exists
            return null; // or redirect, or throw an error, depending on your needs
        }
        const base64Url = token.split('.')[1];
        if (!base64Url) {
            throw new Error("Invalid JWT: Missing payload.");
        }

        // Replace Base64URL-specific characters with Base64 standard characters
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

        // Decode the Base64 string and handle any UTF-8 characters correctly
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch (error) {
        // If Parsing token results in error means token is malformed and user must return to login screen
        console.error("Error decoding token:", error); // Log the error for debugging
        window.location.href = '/login';
        return null; // Return null to prevent further errors
    }
};

export const isTokenExpired = () => {
    return jwtDecode()?.exp < (Date.now() / 1000);
};

export const hasRole = (requiredRole) => {
    const roles = jwtDecode()?.roles;
    if (!Array.isArray(roles)) {
        return false;
    }

    const normalizedRole = String(requiredRole).trim().toLowerCase();
    return roles.some((role) => String(role).trim().toLowerCase() === normalizedRole);
};

export const isSuperadmin = () => hasRole('superadmin');

export const getExpandedAuthorities = (authorities = []) => {
    if (authorities.length === 0) {
        return [];
    }
    let expandedAuthorities = [];
    authorities?.forEach(cur => {
        const [permissionSuffix, permissionPrefix] = cur.split("-");
        if (permissionPrefix && permissionPrefix.length > 1) { // Check if permissionPrefix exists
            const permission = permissionPrefix.split("").map(per => `${permissionSuffix}-${per}`);
            expandedAuthorities.push(...permission);
        } else {
            expandedAuthorities.push(cur);
        }
    });
    return expandedAuthorities;
};

export const hasPermission = (permissions, isMatchAll = false) => {
    const decodedToken = jwtDecode();
    if (!decodedToken || !decodedToken.grantedAuthorities) { // Handle cases where token is invalid or doesn't have authorities
        return false;
    }
    const grantedAuthorities = getExpandedAuthorities(decodedToken.grantedAuthorities);

    return isMatchAll
        ? permissions.every(permission => grantedAuthorities.includes(permission))
        : permissions.some(userPermission => grantedAuthorities.includes(userPermission));
};
